import React from 'react';
import {ListRenderItemInfo, View} from 'react-native';
import {FlatList} from 'react-native-gesture-handler';

import Text from '/component/base/Text';
import {keyExtractor} from '/component/screen/ReleaseNotes/ReleaseNotes.util';

import {styles} from './Content.style';
import {Point} from './Point';

// Define the interface for the item prop structure
interface ContentProps {
  item: {
    title: string;
    description: string;
    points: string[];
  };
}

export const Content: React.FC<ContentProps> = ({
  item = {
    title: '',
    description: '',
    points: [],
  },
}: ContentProps) => {
  const {title, description, points} = item;

  const renderItem = ({item}: ListRenderItemInfo<string>) => (
    <Point item={item} />
  );

  return (
    <View style={styles.container}>
      <Text variant="medium" style={styles.title}>
        {title}
      </Text>
      <Text variant="small" style={styles.description}>
        {description}
      </Text>
      <View style={styles.pointsContainer}>
        <FlatList
          keyExtractor={keyExtractor}
          data={points}
          renderItem={renderItem}
        />
      </View>
    </View>
  );
};
